module.exports = __webpack_public_path__ + "static/img/3-design-b1.e0a9b4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-design-b1.jpg
// module id = jlZZ
// module chunks = 0